var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepair(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H25.9934C33.7254 0 39.9934 6.26801 39.9934 14V25.9934C39.9934 33.7254 33.7254 39.9934 25.9934 39.9934H14C6.26801 39.9934 0 33.7254 0 25.9934V14Z",
    fill: "#FEF2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8028_404)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2463 15.2474C22.0936 15.4032 22.0081 15.6126 22.0081 15.8307C22.0081 16.0488 22.0936 16.2582 22.2463 16.4139L23.5794 17.747C23.7351 17.8997 23.9445 17.9852 24.1626 17.9852C24.3807 17.9852 24.5901 17.8997 24.7459 17.747L27.3338 15.16C27.6004 14.8917 28.0528 14.9767 28.1528 15.3416C28.4045 16.2572 28.3903 17.2255 28.1118 18.1333C27.8333 19.0411 27.302 19.8508 26.5801 20.4676C25.8581 21.0845 24.9755 21.4829 24.0354 21.6164C23.0952 21.7499 22.1365 21.6129 21.2714 21.2215L14.6809 27.812C14.3494 28.1434 13.8999 28.3295 13.4312 28.3294C12.9625 28.3293 12.513 28.1431 12.1817 27.8116C11.8503 27.4801 11.6642 27.0306 11.6643 26.5619C11.6644 26.0933 11.8506 25.6438 12.1821 25.3124L18.7727 18.7219C18.3812 17.8568 18.2442 16.8981 18.3777 15.9579C18.5112 15.0178 18.9097 14.1352 19.5265 13.4133C20.1434 12.6913 20.9531 12.16 21.8609 11.8815C22.7686 11.603 23.737 11.5888 24.6526 11.8405C25.0175 11.9405 25.1025 12.3921 24.835 12.6604L22.2463 15.2474Z",
    stroke: "#E7000B",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8028_404"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9967,
    height: 19.9967,
    fill: "white",
    transform: "translate(9.99829 9.99829)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepair);
export default __webpack_public_path__ + "static/media/repair.77f939ab644d1f5f13218b27a5639d6f.svg";
export { ForwardRef as ReactComponent };